<template lang="pug">
  div(v-if='data.length>0 && $allowAdv')
    .activity_box(v-if="activity && maxImgSrc")
      img(:src="maxImgSrc" @click="go_activityDetail()")
      img(class='close_btn' src="/static/icon/activity_close.png" @click="activity_close()")
      div(class='close_text' @click="activity_close()") 关闭
    .activity_mask(v-if="activity && maxImgSrc" @click="activity_close()")
    .activity_mix(v-if="!activity && mixImgSrc" @click="go_activityDetail()")
      img(:src="mixImgSrc")
</template>

<script>
import { setPiontByHosInfo } from '@/pages/registration/setPiont/setPiontRegistretion'
export default {
  props: {
    data: {
      type: Array
    },
    setPiontData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      activity: false,
      maxImgSrc: this.data[0].popup,
      mixImgSrc: this.data[0].suspension
    }
  },
  created() {
    //      let date = Date.parse(new Date())
    //      if (date < 1541433600000) {
    //        this.imgSrc = 'http://img.ynhdkc.com/activity/20181105_max.png'
    //      } else if (date > 1541433600000 && date < 1541520000000) {
    //        this.imgSrc = 'http://img.ynhdkc.com/activity/20181105_max1.png'
    //      } else {
    //        this.imgSrc = 'http://img.ynhdkc.com/activity/20181105_max2.png'
    //      }
    if (this.data[0].isShow === 1) {
      this.activity = true
    } else {
      this.activity = false
    }
    // 弹窗展示
    if (this.data[0].isShow === 1 && this.data[0].popup) {
      // 体检首页弹窗展示
      if (this.setPiontData && this.setPiontData.pointKey == 'EV_CHECK_DIALOG') {
        this.hina.track('EV_CHECK_DIALOG_SHOW', {
          adv_banner_id:this.data[0].id,
          adv_url:this.data[0].landingPage,
        })
        return
      }
    }
    if(!this.setPiontData || this.setPiontData == {}){
      this.hina.track('EV_HH_DIALOG_CLICK', {
            adv_banner_id:this.data[0].id,
            adv_url:this.data[0].landingPage,
            hos_area_name:this.setPiontData.hospital_area_name,
            hos_code:this.setPiontData.hos_code,
          })
        }else {
        setPiontByHosInfo(this.setPiontData.name.replace('CLICK','SHOW'),this.$route.query.hos_code,
          {adv_banner_id:this.data[0].id,
            adv_url:this.data[0].landingPage,...this.setPiontData})
        }
  },
  methods: {
    go_activityDetail() {
      try {
        if (this.setPiontData && this.setPiontData.pointKey == 'EV_CHECK_DIALOG') {
          this.hina.track('EV_CHECK_DIALOG_CLICK', {
            adv_banner_id:this.data[0].id,
            adv_url:this.data[0].landingPage
          })
        }
        else if(!this.setPiontData || this.setPiontData == {}){
          this.hina.track('EV_HH_DIALOG_CLICK', {
            adv_banner_id:this.data[0].id,
            adv_url:this.data[0].landingPage,
            hos_area_name:this.setPiontData.hospital_area_name,
            hos_code:this.setPiontData.hos_code,
          })
        }else {
        setPiontByHosInfo(this.setPiontData.name,this.$route.query.hos_code,
          {adv_banner_id:this.data[0].id,
            adv_url:this.data[0].landingPage,...this.setPiontData})
        }
      } catch (error) {

      }
      if (this.data[0].landingPage.indexOf('http') > -1) {
        window.location.href = this.data[0].landingPage
      } else {
        this.$router.push(this.data[0].landingPage)
      }
    },
    activity_close() {
      this.activity = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.activity_mask {
  top: 0;
  left: 0;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.7);
}
.activity_mix {
  height: 2.4rem;
  width: 0.6rem;
  top: 40%;
  right: 0;
  position: fixed;
  z-index: 998;
  img {
    width: 100%;
    height: 100%;
  }
}
.activity_box {
  top: 10%;
  left: 15%;
  width: 70%;
  position: fixed;
  z-index: 999;
  overflow: hidden;
  border-radius: 10px;
  .close_btn {
    width: 15%;
    padding: 0 42.5%;
    padding-top: 10%;
  }
  .close_text {
    text-align: center;
    width: 15%;
    padding: 0 42.5%;
    padding-top: 2%;
    color: #fff;
    font-size: 0.43rem;
  }
  img {
    width: 100%;
    border-radius: 10px;
    display: block;
  }
}
</style>
